
import { Vue, Component } from 'vue-property-decorator';
import WorkbenchesService from '@/services/workbenches.service';
import lazyInject from '@/di';

@Component
export default class LookGoodDrawer extends Vue {
  visible = false;

  @lazyInject(WorkbenchesService)
  workbenchesService!: WorkbenchesService;

  data: any = [];

  columns = [
    {
      title: '城市',
      dataIndex: 'city',
      key: 'city',
      align: 'center',
      width: '200px',
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      key: 'shop_name',
      align: 'center',
      width: '200px',
    },
    {
      title: 'POI',
      dataIndex: 'poi',
      key: 'poi',
      align: 'center',
      width: '200px',
    },
    {
      title: '门店ID',
      dataIndex: 'shop_id',
      key: 'shop_id',
      align: 'center',
      width: '200px',
    },
    {
      title: '营业状态',
      dataIndex: 'on_line_status_str',
      key: 'on_line_status_str',
      align: 'center',
      width: '200px',
    },
    {
      title: '商品ID',
      dataIndex: 'goods_id',
      key: 'goods_id',
      align: 'center',
      width: '200px',
    },
    {
      title: '商品名称',
      dataIndex: 'goods_name',
      key: 'goods_name',
      align: 'center',
      width: '200px',
    },
    {
      title: '报名时间',
      dataIndex: 'join_time',
      key: 'join_time',
      align: 'center',
      width: '200px',
    },
  ];

  pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    onChange: this.onChange,
  };

  title = '查看商品';

  userId: any = '';

  shopId: any = '';

  onChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getList(this.pagination);
  }

  init(val: any) {
    this.userId = val.user_id;

    this.shopId = val.shop_id;
    this.pagination.current = 1;
    this.getList(this.pagination);
  }

  async getList(params: any) {
    const _params = {
      page: params.current,
      pageSize: params.pageSize,
      user_id: this.userId,
      shop_id: this.shopId,
    };
    const res = await this.workbenchesService.getCpsGoods(_params);
    if (res) {
      this.visible = true;
      this.data = res;
      // this.pagination.total = res.total;
    }
  }

  onClose() {
    this.visible = false;
  }
}
